// declare const Buffer
// import { Buffer } from 'buffer/';
// import { DataTablesModule } from 'angular-datatables';
import {
  Component,
  OnInit,
  OnChanges,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { QuestionnaireService } from "app/services/questionnaire.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HelperService } from "app/services/helper.service";
import { TosterMessageService } from "app/services/toster-message.service";
import { NgForm } from "@angular/forms";
import { QuestionBankService } from "../../services/question-bank.service";
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
// import { config, S3 } from 'aws-sdk';
import { UploadService } from "app/services/upload.service";
import {DmsAccessService} from "app/services/dms-access.service";
import {DownloadService} from "app/services/download.service";
import { API_URL } from '../../config'
import {
  DropzoneComponent,
  DropzoneConfigInterface,
  DropzoneDirective,
} from "ngx-dropzone-wrapper";


@Component({
  selector: "app-question-bank-add-new-mcq-modal",
  templateUrl: "./question-bank-add-new-mcq-modal.component.html",
  styleUrls: ["./question-bank-add-new-mcq-modal.component.scss"],
  providers: [QuestionBankService, DmsAccessService, DownloadService],
})
export class QuestionBankNewQueAddMcqComponent implements OnInit, OnChanges {
  isHide: any = 1;

  base64Image: string | undefined;
  selectedImage: any = {};

  answerForm: FormGroup;
  sortOrder: number = 0;
  entity: any = {};
  correctAnsweIndex: number;

  public masterData: any = {};
  formData = {
    correct_answer: "",
    correct_all_answer: "",
    answer: "",
    media_type: "",
    media_link: "",
    marks: "",
    auto_id: "",
    url: "",
  };

  selectedFile: any = {};
  isLoading = false;

  isEdit: number;
  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  @Input() auto_id: number;
  @Input() header_id_2: number;

  @ViewChild("form") form: NgForm;
  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;

  @ViewChild(DropzoneComponent) public componentRef?: DropzoneComponent;
  public dbData = [];
  public dbData2 = [];
  public dbDataAction = [];
  @Input("documentSystemCode") public documentSystemCode: any;
  @Input("documentSystemID") public documentSystemID: any;
  @Input("trainingRecordID") public trainingRecordID: any;

  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  companySystemID = +this.helperService.getSelectedCompanyId();

  constructor(
    public bsModalRef: BsModalRef,
    private helperService: HelperService,
    private modalService: BsModalService,
    private QuestionBankService: QuestionBankService,
    private frmbuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private UploadService: UploadService,
    private tosterMessageService: TosterMessageService,
    private dmsAccessService: DmsAccessService,
    private downloadService: DownloadService,

  ) { }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("designation_closed");
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }


  
  onMediaTypeChange($event) {
    if ($event.target.value !== "1") {
      this.isHide = 0;
    } else {
      this.isHide = 1;
    }
  }



  ngOnInit() {
    this.auto_id = Number(localStorage.getItem("question-bank-edit-auto-id"));
    localStorage.removeItem("question-bank-edit-auto-id");
    this.header_id_2 = Number(localStorage.getItem("question-bank-edit-header-id"));
    localStorage.removeItem("file");

    setInterval(()=> { 
      if(localStorage.getItem("file")){
        this.isLoading = false;
      }
    }, 1500);
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = false;
  }


  async onFileSelected(event: any) {
    this.isLoading = true;
    this.selectedFile = event.target.files[0];
    const response = await this.UploadService.uploadFile(this.selectedFile);
  }



  addMCQAnswers(formData: any) {

    const storedFiles = JSON.parse(localStorage.getItem('uploadedFilesQuestionBankAnswer') || '[]');
    console.log(storedFiles);
    // const filePath = storedFiles.length > 0 ? `${API_URL}/${this.dbData[0].path}${storedFiles[0]}` : null;
    const filePath = this.dbData.length > 0 ? this.dbData[this.dbData.length - 1].url : null;

    const requestData = {
      correct_answer: formData.correct_answer,
      correct_all_answer: formData.correct_all_answer,
      answer: formData.answer,
      media_type: formData.media_type,
      // media_link: localStorage.getItem("file"),
      // media_link: formData.media_type === '3' ? formData.media_link : localStorage.getItem("file"),

      media_link:
      formData.media_type === '3'
        ? formData.media_link
        : formData.media_type === '1' || formData.media_type === '4'
        ? filePath
        : null,

      url: storedFiles.length > 0 ? storedFiles[0] : null,
      sort_order: formData.sort_order,
      marks: formData.marks,
      companySystemID: this.companySystemID,
      header_id: this.auto_id,
      header_detail_id: this.header_id_2,
    };
    localStorage.removeItem("file");

    console.log(requestData);
    let that = this;
    that.masterData.companySystemID = that.companySystemID;
    that.masterData.header_id = that.auto_id;
    that.QuestionBankService.createNewMCQQuestionBank()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          //console.log(resp);
          that.masterData = {};
          that.successMsg = "";
          that.successMsg = "Successfully Record Added";
          that.showSuccessHtml();
          this.tableReload.emit();
          localStorage.removeItem('uploadedFilesQuestionBankAnswer');
        },
        (error) => {
          that.htmlErrorMessage = "";
          if (error.status == 500) {
            that.htmlErrorMessage = error.data.message;
            that.showErrorHtml();
          } else if (error.status == 422) {
            that.htmlErrorMessage = that.helperService.serverSideError422(
              error.data.message
            );
            that.showErrorHtml();
          }
          this.tableReload.emit();
          localStorage.removeItem('uploadedFilesQuestionBankAnswer');
        }
      );
    this.tableReload.emit();
  }





  



  public queuecomplete() {
    this.getalldbmsfiles();
    setTimeout(() => {
      this.componentRef.directiveRef.reset();
    }, 2000);
  }


  public getalldbmsfiles() {
    const that = this;
    const item: any = [];
    item.companySystemID = that.helperService.getSelectedCompanyId();
    item.documentSystemCode = this.auto_id;
    item.documentSystemID = 36;
    item.trainingRecordID = undefined;

    console.log(item.companySystemID);
    console.log(item.documentSystemCode);
    console.log(item.documentSystemID);
    console.log(item.trainingRecordID);

    let requestObservable;
      requestObservable = that.dmsAccessService.getAllcommonFilesWeb();
      requestObservable
      .get(item)
      .subscribe(
        (resp) => {
          that.dbData = resp.data.data.master;

          that.dbData2 = that.dbData.length > 0 ? that.dbData[that.dbData.length - 1] : null;
          console.log(that.dbData);
          // console.log(that.dbData2.url);

          that.dbDataAction = resp.data.data.action;
        },
        (error) => {
        }
      );
  }


  public onSending(data): void {
    const file = data[0];
    const formData = data[2];
    formData.append("id", this.helperService.getuserID());
    formData.append("documentSystemID", 36);
    formData.append("masterID", this.auto_id);
    formData.append("trainingRecordID", this.trainingRecordID);
    formData.append("companySystemID", this.helperService.getSelectedCompanyId());
    localStorage.removeItem('uploadedFilesQuestionBankAnswer');
  }


  public onSuccess(event): void {
    const response = event[1];
    if (response.success && response.data.pathFileName) {
      const existingFiles = JSON.parse(localStorage.getItem('uploadedFilesQuestionBankAnswer') || '[]');
      console.log(existingFiles[0]);

      existingFiles.push(response.data.pathFileName);
      console.log(existingFiles[0]);

      localStorage.setItem('uploadedFilesQuestionBankAnswer', JSON.stringify(existingFiles));
    }
  }


  public config: DropzoneConfigInterface = {
    url: API_URL+"/api/v1/uploaddmsfilesTraining",
    clickable: true,
    maxFiles: 1,
    autoReset: null,
    errorReset: null,
    cancelReset: null,
    headers: this.downloadService.createAuthHeaderFileUpload(),
  };

  public selectedItem: any;
  @ViewChild("swalModalDelete") public swalModalDelete: any;

  public deletecommonFile(attachmentID) {
    console.log(attachmentID);
    this.selectedItem = attachmentID;
    this.swalModalDelete.show();
  }

  public removeItem() {
    const that = this;
    this.dmsAccessService
      .deleteCommonFiles()
      .get({id: this.selectedItem})
      .subscribe(
        (resp) => {
          this.tosterMessageService.showSuccess(
            "Success",
            "Successfully deleted"
          );
          this.getalldbmsfiles();
          this.dbData2 = [];
        },
        (error) => {
          this.tosterMessageService.showError("Error", "Unable to delete");
        }
      );
  }

}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-add-new-mcq-modal/question-bank-add-new-mcq-modal.component.ts